type CreateAgentAnalyticsMetadata = {
	flowKey?: string | null;
	issueId?: string | null;
};

type CreateAgentAnalyticsAttributes = {
	issueId: string | undefined;
	inlineAgentCreationFlowKey: string | undefined;
	jiraInlineAgentCreationFlowKey?: string;
};

export const getCreateAgentAnalyticsAttributes = ({
	flowKey,
	issueId,
}: CreateAgentAnalyticsMetadata): CreateAgentAnalyticsAttributes => ({
	issueId: issueId ?? undefined,
	inlineAgentCreationFlowKey: flowKey ?? undefined,
	...(flowKey && issueId ? { jiraInlineAgentCreationFlowKey: flowKey } : {}),
});
